import axios from 'axios';

const apiKey = process.env.REACT_APP_API_KEY
const ga4Url = process.env.REACT_APP_GA4_URL

// Accounts come from the GA4 Admin API, mapped to the { id, name } shape the
// account selector renders.
export const GetGA4Accounts = async (accessToken) => {
  let bearer = 'Bearer ' + accessToken;
  return await axios.get(`${ga4Url}/accounts`, {
    params: { key: apiKey },
    headers: {
      'Authorization': bearer,
      'Content-Type': 'application/json'
    }
  })
    .then(res => (res.data.accounts || []).map(account => ({
      id: (account.name || '').replace('accounts/', ''),
      name: account.displayName
    })))
    // Returning the bare status string preserves the caller's existing
    // UNAUTHENTICATED / PERMISSION_DENIED handling; null means no response.
    .catch((error) => error.response?.data?.error?.status ?? null)
}

// Common Function For getting Account and Property data
export const GetGA4Info = async (url, params, accessToken) => {
  let bearer = 'Bearer ' + accessToken;
  let newConfig = {
    params: params,
    headers: {
      'Authorization': bearer,
      'Content-Type': 'application/json'
    },
  }
  return await axios.get(`${url}`, newConfig)
    .then(res => {
      let response = res
      return response.data;
    })
    .catch((error) => {
      return error
    })
}
// Runs a GA4 Data API report request.
export const GA4Report = async (url, body, accessToken) => {
  let bearer = 'Bearer ' + accessToken;
  let params = {
    alt: 'json',
    key: apiKey
  }
  let header = {
    'Authorization': bearer,
    'Content-Type': 'application/json'
  }

  return await axios.post(`${url}`, body,
    { params: params, headers: header }
  )
    .then(res => {
      return res;
    })
    .catch((error) => {
      return error
    })
}


export const backendApi = async (url, body, token) => {
  let headers = {
    'x-access-token': token,
    'Content-Type': 'application/json'
  }
  return await axios.post(url,
    body, { headers: headers })
    .then(res => {
      return res.data;
    })
    .catch((error) => {
      return error
    })
}

export const removeToken = async (url) => {
  return await axios.get(url)
    .then(res => {
      return res;
    })
    .catch((error) => {
      return error
    })
}

// Sign-out revocation. The old accounts.google.com/o/oauth2/revoke endpoint
// belongs to the retired Sign-In platform; oauth2.googleapis.com/revoke is the
// current one, and it expects a form-encoded POST rather than a GET.
export const revokeGoogleToken = async (accessToken) => {
  if (!accessToken) return null
  return await axios.post('https://oauth2.googleapis.com/revoke',
    new URLSearchParams({ token: accessToken }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then(res => {
      return res;
    })
    .catch((error) => {
      return error
    })
}

// Google Identity Services returns an access token only, so the signed-in
// user's profile is read from the OpenID userinfo endpoint.
export const getGoogleUserInfo = async (accessToken) => {
  return await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
    headers: { 'Authorization': 'Bearer ' + accessToken }
  })
    .then(res => res.data)
    .catch(() => null)
}
